module.exports = __webpack_public_path__ + "img/widgets4.a3baea3c.png";